import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
const packageData: Record<string, {
  name: string;
  packageTypes: string;
  price: string;
  position: number;
  publish: string;
  created: string;
}> = {
  '1': {
    name: '3-Class Renewal Package (select your own courses-9 hours)',
    packageTypes: 'generic package',
    price: '49.95',
    position: 1,
    publish: 'yes',
    created: '04/17/2011'
  },
  '2': {
    name: '#1 8-Class Salesperson Renewal Package (Preset-24 hours)',
    packageTypes: 'preset package',
    price: '89.95',
    position: 5,
    publish: 'yes',
    created: '04/17/2011'
  },
  '3': {
    name: '6-Class Salesperson Renewal Package (select your own courses-18 hours)',
    packageTypes: 'generic package',
    price: '69.95',
    position: 3,
    publish: 'yes',
    created: '04/17/2011'
  }
};
export function ViewPackage() {
  const navigate = useNavigate();
  const {
    id
  } = useParams();
  const pkg = packageData[id ?? '1'] ?? packageData['1'];
  return <div className="space-y-4" data-id="element-2597">
      <div className="flex items-center justify-between" data-id="element-2598">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-2599">View Package</h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/packages')} data-id="element-2600">
          ← Back to Packages
        </Button>
      </div>

      <Card data-id="element-2601">
        <CardContent className="pt-6" data-id="element-2602">
          <div className="space-y-6" data-id="element-2603">
            {/* Details table */}
            <div data-id="element-2604">
              <h2 className="text-base font-semibold text-slate-800 mb-3" data-id="element-2605">
                Package
              </h2>
              <table className="text-sm w-full max-w-lg" data-id="element-2606">
                <tbody data-id="element-2607">
                  <tr className="border-b border-slate-100" data-id="element-2608">
                    <td className="py-2 pr-6 font-medium text-slate-700 w-32 align-top" data-id="element-2609">
                      Name
                    </td>
                    <td className="py-2 text-slate-900" data-id="element-2610">{pkg.name}</td>
                  </tr>
                  <tr className="border-b border-slate-100" data-id="element-2611">
                    <td className="py-2 pr-6 font-medium text-slate-700 align-top" data-id="element-2612">
                      Package Types
                    </td>
                    <td className="py-2 text-slate-900" data-id="element-2613">{pkg.packageTypes}</td>
                  </tr>
                  <tr className="border-b border-slate-100" data-id="element-2614">
                    <td className="py-2 pr-6 font-medium text-slate-700" data-id="element-2615">
                      Price
                    </td>
                    <td className="py-2 text-slate-900" data-id="element-2616">{pkg.price}</td>
                  </tr>
                  <tr className="border-b border-slate-100" data-id="element-2617">
                    <td className="py-2 pr-6 font-medium text-slate-700" data-id="element-2618">
                      Position
                    </td>
                    <td className="py-2 text-slate-900" data-id="element-2619">{pkg.position}</td>
                  </tr>
                  <tr className="border-b border-slate-100" data-id="element-2620">
                    <td className="py-2 pr-6 font-medium text-slate-700" data-id="element-2621">
                      Publish
                    </td>
                    <td className="py-2 text-slate-900" data-id="element-2622">{pkg.publish}</td>
                  </tr>
                  <tr data-id="element-2623">
                    <td className="py-2 pr-6 font-medium text-slate-700" data-id="element-2624">
                      Created
                    </td>
                    <td className="py-2 text-slate-900" data-id="element-2625">{pkg.created}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Actions */}
            <div data-id="element-2626">
              <h2 className="text-base font-semibold text-slate-800 mb-2" data-id="element-2627">
                Actions
              </h2>
              <ul className="space-y-1 text-sm" data-id="element-2628">
                <li data-id="element-2629">
                  <button className="text-blue-600 hover:underline" onClick={() => navigate(`/packages/edit/${id}`)} data-id="element-2630">
                    Edit Package
                  </button>
                </li>
                <li data-id="element-2631">
                  <button className="text-blue-600 hover:underline" data-id="element-2632">
                    Delete Package
                  </button>
                </li>
                <li data-id="element-2633">
                  <button className="text-blue-600 hover:underline" onClick={() => navigate('/packages')} data-id="element-2634">
                    List Packages
                  </button>
                </li>
                <li data-id="element-2635">
                  <button className="text-blue-600 hover:underline" onClick={() => navigate('/packages/add')} data-id="element-2636">
                    New Package
                  </button>
                </li>
                <li data-id="element-2637">
                  <button className="text-blue-600 hover:underline" data-id="element-2638">
                    List Package Courses
                  </button>
                </li>
                <li data-id="element-2639">
                  <button className="text-blue-600 hover:underline" data-id="element-2640">
                    New Package Course
                  </button>
                </li>
              </ul>
            </div>

            {/* Related Package Courses */}
            <div data-id="element-2641">
              <h2 className="text-base font-semibold text-slate-800" data-id="element-2642">
                Related Package Courses
              </h2>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>;
}